import type { QueryFilterGroup } from '@/services/api/scanner-types'

/** Filters applied when a scanner panel has no persisted `filters`. */
export const DEFAULT_SCANNER_FILTERS: QueryFilterGroup = {
  AND: [{ left: { column: 'share_group' }, operator: 'in', right: { value: ['CS'] } }],
}
